import {
  GET_PROXY_LOGIN_USER_REQUEST,
  GET_PROXY_LOGIN_USER_SUCCESS,
  GET_PROXY_LOGIN_USER_FAILURE,
} from '../../constants/ActionTypes'

const initialState = {
  user: null,
  isProxyLoginLoading: false,
  proxyLoggedIn: false,
  errorMessage: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PROXY_LOGIN_USER_REQUEST:
      return {
        ...state,
        user: {},
        isProxyLoginLoading: true,
        proxyLoggedIn: false,
      };
    case GET_PROXY_LOGIN_USER_SUCCESS:
      return {
        ...state,
        isProxyLoginLoading: false,
        user: { ...action.payload.user },
        proxyLoggedIn: true,
      };
    case GET_PROXY_LOGIN_USER_FAILURE:
      return {
        ...state,
        isProxyLoginLoading: false,
        proxyLoggedIn: false,
        user: {},
        errorMessage: action.payload.error,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/proxyLoginUser.js